var exports = {
  "kL": "x24da60e8--939c98--container",
  "hF": "x24da60e8--939c98--input",
  "t2": "x24da60e8--939c98--after-icon",
  "$A": "x24da60e8--939c98--cross",
  "fe": "x24da60e8--939c98--selected-options",
  "UE": "x24da60e8--939c98--arrow",
  "SZ": "x24da60e8--939c98--rotated",
};

module.exports = exports;
